import { buildUserIdPayload } from '../utils/userIdPayload';

const BASE = `${process.env.REACT_APP_API_URL}/api/notifications`;
const DEFAULT_LIMIT = 50;

/**
 * Список уведомлений пользователя с пагинацией.
 * POST /api/notifications/list
 * @param {{ platform: 'telegram' | 'max', userId: string | number, page: number, limit?: number }} params
 * @returns {Promise<{ items: Array<{ id: string, type: string, title: string, text: string, created_at: string, files?: unknown }>, pagination: { page: number, limit: number, total: number, pages: number } }>}
 */
export async function getNotificationsList({ platform, userId, page, limit = DEFAULT_LIMIT }) {
    const body = {
        ...buildUserIdPayload(platform, userId),
        page: Number(page),
        limit: Number(limit),
    };

    const response = await window.fetch(`${BASE}/list`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });

    if (!response.ok) {
        throw new Error(`notifications list: ${response.status}`);
    }

    const data = await response.json();
    return {
        items: data?.items ?? [],
        pagination: data?.pagination ?? { page: 1, limit: DEFAULT_LIMIT, total: 0, pages: 0 },
    };
}

/**
 * Получение уведомления по ID.
 * POST /api/notifications/get
 * @param {{ platform: 'telegram' | 'max', userId: string | number, notification_id: string }} params
 * @returns {Promise<{ id: string, type: string, title: string, text: string, created_at: string, files: Array<{ url: string, name: string }> }>}
 */
export async function getNotification({ platform, userId, notification_id }) {
    const body = {
        ...buildUserIdPayload(platform, userId),
        notification_id: String(notification_id),
    };

    const response = await window.fetch(`${BASE}/get`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });

    if (!response.ok) {
        throw new Error(`notification get: ${response.status}`);
    }

    const data = await response.json();
    return {
        id: data?.id ?? '',
        type: data?.type ?? '',
        title: data?.title ?? '',
        text: data?.text ?? '',
        created_at: data?.created_at ?? '',
        contract_number: data?.contract_number ?? '',
        files: Array.isArray(data?.files) ? data.files : [],
    };
}
